"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hrRequisitionQuerySchema = exports.hrRequisitionCloseSchema = exports.hrRequisitionRejectSchema = exports.hrRequisitionApproveSchema = exports.hrRequisitionCreateSchema = exports.hrRequisitionReasonEnum = exports.hrRequisitionStatusEnum = void 0;
const zod_1 = require("zod");
/**
 * HR PHASE 2A — job requisition (recruitment roadmap). Routes through the
 * EXISTING `approval_matrices` (module='HR', action='JOB_REQUISITION'), same
 * auto-approve-if-unconfigured pattern as attendance corrections / overtime /
 * leave — no new approval engine.
 */
exports.hrRequisitionStatusEnum = zod_1.z.enum(['PENDING', 'APPROVED', 'REJECTED', 'CLOSED', 'CANCELLED']);
exports.hrRequisitionReasonEnum = zod_1.z.enum(['NEW_POSITION', 'REPLACEMENT']);
exports.hrRequisitionCreateSchema = zod_1.z
    .object({
    departmentId: zod_1.z.string().uuid(),
    designationId: zod_1.z.string().uuid(),
    branchId: zod_1.z.string().uuid().optional(),
    openings: zod_1.z.coerce.number().int().positive().max(500).default(1),
    reason: exports.hrRequisitionReasonEnum,
    replacesEmployeeId: zod_1.z.string().uuid().optional(),
    qualifications: zod_1.z.string().trim().max(2000).optional(),
    experience: zod_1.z.string().trim().max(200).optional(),
    skills: zod_1.z.string().trim().max(2000).optional(),
    description: zod_1.z.string().trim().max(4000).optional(),
    justification: zod_1.z.string().trim().min(3).max(2000),
})
    .refine((v) => v.reason !== 'REPLACEMENT' || v.replacesEmployeeId, {
    message: 'replacesEmployeeId is required when reason is REPLACEMENT',
    path: ['replacesEmployeeId'],
});
exports.hrRequisitionApproveSchema = zod_1.z.object({
    decisionReason: zod_1.z.string().trim().min(3).max(2000).optional(),
});
exports.hrRequisitionRejectSchema = zod_1.z.object({
    decisionReason: zod_1.z.string().trim().min(3).max(2000),
});
exports.hrRequisitionCloseSchema = zod_1.z.object({
    decisionReason: zod_1.z.string().trim().max(2000).optional(),
});
exports.hrRequisitionQuerySchema = zod_1.z.object({
    departmentId: zod_1.z.string().uuid().optional(),
    status: exports.hrRequisitionStatusEnum.optional(),
    cursor: zod_1.z.string().min(1).max(512).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(50),
});
//# sourceMappingURL=hr-requisition.schema.js.map